import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from './toast.service';


/**
 * Toast component to display feedback messages.
 */
@Component({
	selector: 'app-toast',
	imports: [
		NgbToastModule
	],
	templateUrl: './toast.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	host: { '[class.ngb-toasts]': 'true' }
})
export class ToastComponent {

	public toastSrv = inject(ToastService);

}
